// API Configuration
const API_CONFIG = {
  // Base URL for the API
  // BASE_URL: 'http://localhost:4002',
  BASE_URL: 'https://api.amdavadpost.in',
  
  // API endpoints
  ENDPOINTS: {
    // Authentication endpoints
    LOGIN: '/api/login',
    SIGNUP: '/api/signup',
    
    // News endpoints 
    GET_NEWS: '/api/get-news',
    TRENDING_NEWS: '/api/trending-news',
    VIEW_NEWS: '/api/view-news',
    CREATE_NEWS: '/api/create-news',
    UPDATE_NEWS: '/api/update-news/:id',
    DELETE_NEWS: '/api/delete-news/:id',
    
    // User endpoints
    GET_USERS: '/api/get-users',
    GET_ADMIN_USERS: '/api/get-admin-users',
    UPDATE_USER: '/api/update-user/:userId',
  }
};

// Helper function to build full URL
export const buildApiUrl = (endpoint, params = {}) => {
  let url = `${API_CONFIG.BASE_URL}${endpoint}`;
  
  // Replace URL parameters (e.g., /api/update-news/:id)
  Object.keys(params).forEach(key => {
    url = url.replace(`:${key}`, params[key]);
  });
  
  return url;
};

// Helper function to get full endpoint URL
export const getApiUrl = (endpointKey, params = {}) => {
  const endpoint = API_CONFIG.ENDPOINTS[endpointKey];
  if (!endpoint) {
    throw new Error(`Endpoint ${endpointKey} not found in API configuration`);
  }
  return buildApiUrl(endpoint, params);
};

// Export the config for direct access if needed
export default API_CONFIG;